module.exports = __webpack_public_path__ + "static/img/4.ac61d9de.png";